export const ENROLL_SERIES_REQUEST = 'ENROLL_SERIES_REQUEST';
export const ENROLL_SERIES_SUCCESS = 'ENROLL_SERIES_SUCCESS';
export const ENROLL_SERIES_FAILURE = 'ENROLL_SERIES_FAILURE';
export const GET_SERIES_BY_ID_REQUEST = 'GET_SERIES_BY_ID_REQUEST';
export const GET_SERIES_BY_ID_SUCCESS = 'GET_SERIES_BY_ID_SUCCESS';
export const GET_SERIES_BY_ID_FAILURE = 'GET_SERIES_BY_ID_FAILURE';
export const UPDATE_SERIES_REQUEST = 'UPDATE_SERIES_REQUEST';
export const UPDATE_SERIES_SUCCESS = 'UPDATE_SERIES_SUCCESS';
export const UPDATE_SERIES_FAILURE = 'UPDATE_SERIES_FAILURE';
export const UPDATE_SERIES_BOOKING_PROGRESS_REQUEST = 'UPDATE_SERIES_BOOKING_PROGRESS_REQUEST';
export const UPDATE_SERIES_BOOKING_PROGRESS_SUCCESS = 'UPDATE_SERIES_BOOKING_PROGRESS_SUCCESS';
export const UPDATE_SERIES_BOOKING_PROGRESS_FAILURE = 'UPDATE_SERIES_BOOKING_PROGRESS_FAILURE';
export const GET_SERIES_BY_USER_ID_REQUEST = 'GET_SERIES_BY_USER_ID_REQUEST';
export const GET_SERIES_BY_USER_ID_SUCCESS = 'GET_SERIES_BY_USER_ID_SUCCESS';
export const GET_SERIES_BY_USER_ID_FAILURE = 'GET_SERIES_BY_USER_ID_FAILURE';
export const SET_SERIES_SERVICE_DETAILS = 'SET_SERIES_SERVICE_DETAILS';